<template>
  <router-view />
</template>

<script>
export default {
  name: "SingleTicketStatsIndex",
};
</script>

<style scoped>
</style>